import * as React from "react";
import { forwardRef } from "react";
const SvgConfigAdm = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ React.createElement("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props
}, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", {
	d: "M10.717 3.34998C11.5109 2.88334 12.4891 2.88334 13.283 3.34998L18.717 6.54385C19.5109 7.01048 20 7.87286 20 8.80613V15.1939C20 16.1271 19.5109 16.9895 18.717 17.4562L13.283 20.65C12.4891 21.1167 11.5109 21.1167 10.717 20.65L5.283 17.4562C4.48908 16.9895 4 16.1271 4 15.1939V8.80613C4 7.87286 4.48908 7.01048 5.283 6.54385L10.717 3.34998Z",
	stroke: "currentColor",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("circle", {
	cx: 12,
	cy: 12,
	r: 3,
	stroke: "currentColor",
	strokeWidth: 1.5
}));
const ForwardRef = forwardRef(SvgConfigAdm);
export default ForwardRef;
